import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';

export class GetContractorEmployeeCommand extends IRequestCommand<
    IGetContractorEmployeeResponse,
    ErrorDetails,
    IGetContractorEmployeeCommandRequest
> {
    override _commandType: CommandRequestType = CommandRequestType.GET;

    public override setParameters(params: IGetContractorEmployeeCommandRequest) {
        this.urlSections.push('contractorEmployees');
        this.urlSections.push(`${params.id}`);
        this.composeUrl();
    }
}

export interface IGetContractorEmployeeCommandRequest
    extends ICommandParameters {
    id: number;
}

export interface IGetContractorEmployeeResponse extends ICommandResponse {}
